var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@nivo/core';

var tableStyle = {
    width: '100%',
    borderCollapse: 'collapse'
};

var TableTooltip = memo(function (_ref) {
    var title = _ref.title,
        rows = _ref.rows,
        renderContent = _ref.renderContent;

    var theme = useTheme();

    if (!rows.length) return null;

    var content = void 0;
    if (typeof renderContent === 'function') {
        content = renderContent();
    } else {
        content = React.createElement(
            'div',
            null,
            title && title,
            React.createElement(
                'table',
                { style: _extends({}, tableStyle, theme.tooltip.table) },
                React.createElement(
                    'tbody',
                    null,
                    rows.map(function (row, i) {
                        return React.createElement(
                            'tr',
                            { key: i },
                            row.map(function (column, j) {
                                return React.createElement(
                                    'td',
                                    { key: j, style: theme.tooltip.tableCell },
                                    column
                                );
                            })
                        );
                    })
                )
            )
        );
    }

    return React.createElement(
        'div',
        { style: theme.tooltip.container },
        content
    );
});

TableTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
    title: PropTypes.node,
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
    renderContent: PropTypes.func
} : {};

TableTooltip.displayName = 'TableTooltip';

export default TableTooltip;